<template>
  <div class="container">
    <el-row class="common-box">
      <div class="common-search">
        <el-tabs type="border-card" class="card-tab">
          <el-form
            :model="param"
            :inline="true"
            label-width="125px"
            class="formInline"
            size="mini"
          >
            <div class="slide-wrap" ref="slideWrap1">
              <el-form-item label="项目编号">
                <el-input
                  v-model="formData.projectCode"
                  placeholder="请输入..."
                  :maxlength="80"
                ></el-input>
              </el-form-item>
              <el-form-item label="项目名称">
                <el-input
                  v-model="formData.projectName"
                  placeholder="请输入..."
                  :maxlength="80"
                ></el-input>
              </el-form-item>
              <el-form-item label="是否映射" prop="serviceSupplier">
                <el-select v-model="formData.mapper" filterable placeholder="请选择是否映射...">
                  <el-option label="不限" :value="null"></el-option>
                  <el-option label="已映射" value="1"></el-option>
                  <el-option label="未映射" value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="text" class="reset-btn" @click="resetForm()">清空</el-button>
                <el-button class="search-btn" @click="submitForm()"
                  >筛选</el-button
                >
              </el-form-item>
            </div>
            <hr style="margin-bottom: 9px" />
          </el-form>
      </el-tabs>
      </div>
      <div class="common-box-body">
        <el-table :data="tableData" size="small" v-loading="listLoading" element-loading-text="拼命加载中" border
                  style="width: 100%" header-row-class-name="table-header">
          <el-table-column type="index" label="#" width="50" align="center"></el-table-column>
          <el-table-column prop="projectCode" label="项目编号" align="center"></el-table-column>
          <el-table-column prop="projectName" label="项目名称" align="center"></el-table-column>
          <el-table-column prop="startTime" label="项目开始日期" align="center"></el-table-column>
          <el-table-column prop="endTime" label="项目结束日期" align="center"></el-table-column>
          <el-table-column prop="mapperProjectCode" label="映射项目编号（HAP）" align="center"></el-table-column>
          <el-table-column prop="mapperProjectName" label="映射项目名称（HAP）" align="center"></el-table-column>
          <el-table-column prop="updateTimeStr" label="更新时间" align="center"></el-table-column>
          <el-table-column prop="updateUser" label="更新人" align="center"></el-table-column>
          <el-table-column  label="操作" align="center">
            <template slot-scope="scope">
              <span style="color: #1652ff; cursor: pointer;" @click="openEditDialog(scope.row.id, scope.row.projectCode, scope.row.projectName, scope.row.mapperProjectCode)">修改</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination class="pagination table-pagination"
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page="formData.pageNo"
                       :page-sizes="[10, 20, 30, 40]"
                       :page-size="formData.pageSize"
                       layout="slot, total, sizes, prev, pager, next, jumper"
                       :total="total">
        </el-pagination>
      </div>
    </el-row>
    <el-dialog :title="'修改项目映射：' + projectName" :visible.sync="showEditDialog" width="30%" center>
      <hr style="margin-bottom: 9px">
      <div style="text-align: center; margin-top: 50px;">
        <div>
          <div style="text-align:left;margin-bottom:10px;">当前项目编码：{{ projectCode }}</div>
        </div>
        <div>
          <div style="text-align:left;margin-bottom:10px;margin-top:20px;">映射项目编码（HAP）：</div>
          <div ><el-input v-model="mapperProjectCode" ></el-input></div>
        </div>
        
        <div style="text-align:center;margin-top:30px;">
          <el-button class="search-btn" @click="editMapperProject">确定</el-button>
          <el-button class="search-btn" @click="showEditDialog=false">取消</el-button>
        </div>
      </div>

    </el-dialog>
  </div>
</template>

<script>
  import utils from '../../../common/js/util.js'

  export default {
    data() {
      return {
        param: {},
        formData: {
          pageNo: 1,
          pageSize: 10,
          projectCode: null,
          projectName: null,
          mapper: null,
        },
        tableData: [],
        total: null,
        listLoading: false,

        id: null,
        projectCode: null,
        projectName: null,
        mapperProjectCode: null,
        showEditDialog:false,
      }
    },
    mounted() {

      this.getData();
    },
    methods: {
      getData() {
        this.listLoading = true;
        this.$http({
          method: 'GET',
          url: '/rest/project/mapperProjectList',
          params: this.formData
        }).then(res => {
          this.tableData = res.data.items;
          this.total = res.data.totalItemsCount;
          this.listLoading = false;
        }).catch(err => {
          this.listLoading = false;
        })
      },
      submitForm() {
        this.formData.pageSize = 10;
        this.formData.pageNo = 1;
        this.getData();
      },
      resetForm() {
        this.formData.projectCode = null;
        this.formData.projectName = null;
        this.formData.mapper = null;
      },
      handleSizeChange(val) {
        this.formData.pageSize = val;
        this.getData();
      },
      handleCurrentChange(val) {
        this.formData.pageNo = val;
        this.getData();
      },
      openEditDialog(id, projectCode, projectName, mapperProjectCode) {
        this.showEditDialog = true;
        this.id = id;
        this.projectCode = projectCode;
        this.projectName = projectName;
        this.mapperProjectCode = mapperProjectCode;
      },
      editMapperProject() {
        // if (!this.mapperProjectCode) {  
        // this.showError = true; // 提交前再次检查  
        // utils.myNotify(this, "error", "error", '项目映射编码不能为空！');
        // return;  
        // } 
        this.$http({
          method: 'POST',
          url: '/rest/project/editMapperProject',
          data: {
            id: this.id,
            projectCode: this.projectCode,
            projectName: this.projectName,
            mapperProjectCode: this.mapperProjectCode
          }
        }).then(res => {
          this.showEditDialog = false;
          utils.myNotify(this, "success", res, '操作成功');
          this.getData();
        }).catch(err => {
          // debugger
          console.log('err.message:' + err.response.data.message)
          utils.myNotify(this, "error", "error", err.response.data.message);
        })
      },

    }
  }
</script>

<style lang="scss" scoped>
  .search-btn {
    margin-left: 30px;
    margin-right: 30px;
  }
</style>




// WEBPACK FOOTER //
// src/views/configCanage/mapper/MapperProject.vue